import { Component, OnInit } from '@angular/core';
import { MasterDataService } from '../../services/master-data.service';
import { CommonMessageService } from '../../services/common-message.service';

@Component({
  selector: 'app-update-budget',
  templateUrl: './update-budget.component.html',
  styleUrls: ['./update-budget.component.css']
})
export class UpdateBudgetComponent implements OnInit {
  employeeList;
  financialList;
  selectedFinancialYear;;
  selectedEmployee;
  updatBudgetReportList;
  constructor(private masterDataService: MasterDataService,
    private commonMessageService: CommonMessageService) { }

  ngOnInit(): void {
    this.selectedFinancialYear = "";
    this.selectedEmployee = "";
    this.loadInitDetails();
  }

  loadInitDetails() {
    this.masterDataService.getFinancialYear()
      .subscribe(res => {
        this.financialList = res;
      });

    this.masterDataService.getPartners()
      .subscribe(res => {
        this.employeeList = res;
        console.log('employee list', this.employeeList);
      });
  }

  fileList: FileList;
  formData: FormData;
  selectedFile;
  fileChange(event) {
    this.fileList = undefined;
    this.fileList = event.target.files;
    if (this.fileList.length > 0) {
      let file: File = this.fileList[0];
      this.formData = new FormData();
      this.formData.append('file', file, file.name);
    }
  }

  onUpdateBudgetReport() {
    console.log('fyID,PArtnerID', this.selectedFinancialYear.id, this.selectedEmployee.id);
    if (this.selectedFinancialYear == null || this.selectedFinancialYear == "" ||
      this.selectedEmployee == null || this.selectedEmployee == "" ||
      this.selectedFile == null || this.selectedFile == "") {
      this.commonMessageService.swalAlertWithoutIcon('','Please select all fields.');
      return;
    }
    this.masterDataService.getUpdateBudgetReportDetails(this.selectedFinancialYear.id, this.selectedEmployee.id, this.formData).subscribe((resp: any) => {
      console.log('resp details', resp);
      this.updatBudgetReportList = resp;
      this.commonMessageService.updateMessage();
      this.selectedFinancialYear = "";
      this.selectedEmployee = "";
      this.selectedFile = "";
    }, err => {
      console.log("error", err);
      this.selectedFinancialYear = "";
      this.selectedEmployee = "";
      this.selectedFile = "";
    });
  }
}
